import type { JSX } from 'react'
import { cn } from '#src/cn.ts'

export interface IconCommentProps {
  className?: string
}

export function IconComment({ className }: IconCommentProps): JSX.Element {
  return (
    <svg
      aria-label="Comment"
      className={cn('size-4 shrink-0', className)}
      viewBox="0 0 16 16"
      fill="lch(90.65 1.35 272)"
      role="img"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.294 9.485c-.017 1.269-1.042 2.283-2.287 2.265-1.245-.002-2.254-1.03-2.256-2.297v-.578C2.69 6.39 4.614 4.321 7.055 4.25c.315 0 .57.26.57.581 0 .321-.255.581-.57.581A3.11 3.11 0 0 0 4.372 7.05a.118.118 0 0 0-.012.086c.015.062.076.1.138.085a2.068 2.068 0 0 1 .573-.066c1.246.018 2.241 1.062 2.223 2.33ZM12.855 9.42c.018 1.269-.978 2.312-2.223 2.33-1.245-.002-2.255-1.03-2.256-2.297v-.578c-.061-2.485 1.863-4.553 4.303-4.625.316 0 .571.26.571.581 0 .321-.255.581-.57.581A3.11 3.11 0 0 0 9.995 7.05a.118.118 0 0 0-.012.087c.016.062.078.1.139.084.166-.043.337-.065.509-.066 1.22.018 2.206 1.022 2.223 2.265Z"></path>
    </svg>
  )
}
